import { render, staticRenderFns } from "./TermAcceptPopup.vue?vue&type=template&id=4c8a7a2c&scoped=true"
import script from "./TermAcceptPopup.vue?vue&type=script&lang=js"
export * from "./TermAcceptPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a7a2c",
  null
  
)

export default component.exports